import * as React from "react";
import "classnames";
/* empty css                                                           */
import "@grandvisionhq/common";
/* empty css                                                                                                     */
import "@grandvisionhq/elements";
import "@grandvisionhq/lib-utils-html";
import "@grandvisionhq/iris-ui";
import "@grandvisionhq/state";
import "@grandvisionhq/lib-visuals";
import "@grandvisionhq/utils";
/* empty css                                                                                              */
/* empty css                                                                             */
/* empty css                                                                                               */
import "@grandvisionhq/configurator";
import "../../../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../../../state/state/actions.js";
import "../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../state/products/state/products/selectors.js";
import "../../../../../../state/products/state/products/reducer.js";
/* empty css                                                                                                                                               */
/* empty css                                                                                            */
import "@grandvisionhq/commercetools";
/* empty css                                                                                                                        */
/* empty css                                                                                                                           */
/* empty css                                                                                                                                                   */
import "@grandvisionhq/icons";
/* empty css                                                               */
/* empty css                                                           */
/* empty css                                                                                */
import { SelectionsSummary } from "../../../../../SelectionsSummary/components/SelectionsSummary/SelectionsSummary.js";
/* empty css                              */
const RxGlassesExpanderContent = () => {
  return /* @__PURE__ */ React.createElement("div", { className: "rx-glasses-expander-content" }, /* @__PURE__ */ React.createElement(SelectionsSummary, null));
};
export {
  RxGlassesExpanderContent
};
//# sourceMappingURL=RxGlassesExpanderContent.js.map
